export const initialVesselReportsState: object = {};
